import { render, staticRenderFns } from "./FormWordsOfCaution.vue?vue&type=template&id=7c810286"
import script from "./FormWordsOfCaution.vue?vue&type=script&lang=js"
export * from "./FormWordsOfCaution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports